import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'income_level'

const answers: AnswerType[] = [
  {
    emoji: '🪫‍',
    title: 'pages.onboarding.incomeLevel.options.wellBelowAverage',
    value: 'well-below-average-bottom-20',
  },
  {
    emoji: '📉',
    title: 'pages.onboarding.incomeLevel.options.belowAverage',
    value: 'below-average-20-50',
  },
  {
    emoji: '⚖️‍',
    title: 'pages.onboarding.incomeLevel.options.aroundAverage',
    value: 'around-average-50-80',
  },
  {
    emoji: '📈',
    title: 'pages.onboarding.incomeLevel.options.aboveAverageTop20',
    value: 'above-average-top-20',
  },
]

export default function IncomeLevelPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your income level?",
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.incomeLevel.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
